import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { DossierService } from '../dossier.service';
import {
  TenderEvaluationCommitteeDTO,
  TenderingPhaseDTO,
  ProcurementCommitteeDTO,
  TenderingDefinitionViews,
  TenderingPhaseState,
  getSimpleIdentifierFromString
} from '../../api/plyca-dtos';
import { Observable, forkJoin, throwError, of } from 'rxjs';
import { Configuration } from '../../conf/app.constants';
import { PaginationDTO } from '../../api/PaginationModel';
import {
  EnvelopeDTO, ProcurementProjectDTO, ProjectEntityDTO, ValidationResultDTO, ResultTypeDTO, DossierSituation, ActionResultDTO,
  ValidationExecutionDTO
} from '../../api/plyca-dtos-v2';
import { UIService } from '../../ui.service';
import { TaskHandler } from '../../tasks/TaskHandler';
import { tap, catchError, finalize, map, flatMap, take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import * as lodash from 'lodash';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { AppConfiguration } from '../../conf/app.configuration';
import { ServiceLocator } from '../../ServiceLocator';
import { PlycaErrorHandler } from '../../../http/PlycaErrorHandler';
import { DossierModelsService } from '../dossierModels/DossierModels.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'eTenderingDefinition',
  templateUrl: 'eTenderingDefinition.template.html'
})
export class eTenderingDefinitionComponent extends TaskHandler implements OnInit, OnDestroy {

  public project: ProjectEntityDTO;
  public tenderEvaluationCommittees: Array<TenderEvaluationCommitteeDTO>;
  public tenderingEnvelopes: Array<EnvelopeDTO>;
  public envelopeValidations: Map<string, ValidationResultDTO>;
  public tenderingPhases: Array<TenderingPhaseDTO>;
  public tenderingPhasesValidations: Map<string, ValidationResultDTO>;


  private editDialogOpened: boolean;
  public projectAwardCriterias: ProcurementProjectDTO;

  public VIEW_VALUES = TenderingDefinitionViews;
  public view: string;
  public activeViews: string[];
  public loadingValidationResult = new ValidationResultDTO();
  isModel: boolean;
  appConfig: AppConfiguration;

  //INI POP UP de modelos de licitacion
  models: any[];
  tenderModelsPopupVisible = false;
  importFlicVisible = false;
  modelsTenderDefMOD_LIC = true;// indica si solo se muestran los modelos de la ficha de licitación del tipo MOD_LIC, o todos con independiencia del tipo (siempre que tengan datos de licitación)
  //FIN POP UP de modelos de licitacion

  translate: TranslateService;

  constructor(
    public plycaService: PlycaDataService,
    public dossierService: DossierService,
    private configuration: Configuration,
    private uiService2: UIService,
    public activatedRoute: ActivatedRoute,
    private headerActionsService: HeaderActionsService,
    private location: Location,
    private helpService: HelpService,
    private plycaErrorHandler: PlycaErrorHandler,
    public dossierModelService: DossierModelsService,
    private elem: ElementRef
  ) {
    super();
    this.appConfig = ServiceLocator.injector.get(AppConfiguration);
    this.loadingValidationResult.result = ResultTypeDTO.LOADING;
    this.envelopeValidations = new Map();
    this.tenderingPhasesValidations = new Map();
    this.translate = ServiceLocator.injector.get(TranslateService);
  }



  ngOnInit(): void {
    let projectObs: Observable<ProjectEntityDTO>;
    this.waitService.startWaiting();

    if (this.task) {
      console.log('INVOCACIONA PROCUREMENTPROJECT DESDE TAREA', this.task);
      projectObs = of({}).pipe(
        map(() => this.task.division.project)
      );
      if (this.task.work && this.task.work.view) {
        this.view = this.task.work.view;
      } else {
        this.view = TenderingDefinitionViews.OA.toString();
      }
      if (this.task.work && this.task.work.activeViews) {
        this.activeViews = this.task.work.activeViews;
      }
    } else {
      this.subscribe(this.helpService.showContextHelpObservable(HelpType.TENDER_DEFINITION));
      projectObs = this.activatedRoute.params.pipe(
        map((params) => params['id']),
        flatMap((dossierId: string) => {
          return this.plycaService.get<ProjectEntityDTO>(this.configuration.PROJECTENTITY_SERVICE_URL, dossierId);
        })
      );
      let subscription2 = this.activatedRoute.queryParams.pipe(
        map((params) => params['view']),
        tap((view: string) => {
          if (view) {
            this.view = view || TenderingDefinitionViews.OA.toString();
          }
        })
      ).subscribe();
      this.registerSubscription(subscription2);
    }
    this.headerActionsService.setTaskDescription(
      this.elem,
      'TenderDefinition.title',
      'fa-tasks',
      true
    );
    // acciones
    let subscription = projectObs.subscribe((project: ProjectEntityDTO) => {
      this.project = project;
      this.loadTenderDef();
      this.buttonFlicVisible();
    });
    this.registerSubscription(subscription);

    this.loadActions();



  }

  buttonFlicVisible() {
    this.subscribe(this.plycaService.getAvailableAction('IMPORT_FLIC', this.project.identifier, 'PROCUREMENTPROJECT'),
      result => { // TODO: FILTRAR MODELOS DEL TIPO DE EXPEDIENTE SELECCIONADO
        if (result) {
          if (result && result.actions && result.actions[0]) {
            this.importFlicVisible = result.actions[0].enabled;
          }
        }
      },
      err => { console.log('Error ', err); });

  }

  loadTenderDef() {
    if (this.project.documentClass) {
      this.isModel = this.project.documentClass.identifier === this.appConfig.getValue('dossierModel.documentClass');;
    }
    this.headerActionsService.setProject(this.elem, this.project, true);
    if (!this.task) {
      // establecemos la ayuda con las etiquetas del expediente
      let labels = this.helpService.getLabelsByObject([this.project]);
      labels.push(HelpType.TENDER_DEFINITION);
      this.subscribe(this.helpService.showContextHelpObservable(labels));
    }
    let subscription2 = forkJoin(
      this.loadTenderingCommittes(),
      this.loadEnvelopes(),
      this.loadTenderingPhases()
    ).subscribe(
      () => undefined,
      () => undefined,
      () => {
        this.waitService.cancelWaiting();
        this.editDialogOpened = false;
      }
    );
    this.registerSubscription(subscription2);
  }

  loadActions() {
    // accion de modelos de icitacion
    let subscription = this.headerActionsService.addAction(
      'TenderDefinition.import',
      'fas fa-lg fa-file-import',
      'btn-outline-secondary',
      () => this.importFlicVisible
    ).subscribe(success => {
      this.loadModelsTenderDef();
    });
    this.registerSubscription(subscription);

    // accion volver
    this.headerActionsService.addDivider();
    subscription = this.headerActionsService.addAction(
      'General.accept',
      'fas fa-lg fa-check',
      'btn-primary',
      true
    ).subscribe(success => {
      this.back();
    });
    this.registerSubscription(subscription);
  }



  loadModelsTenderDef() {

    //identificador del tipo de expediente
    let id = getSimpleIdentifierFromString(this.project.type.identifier);
    //buscamos los modelos existentes
    this.subscribe(this.dossierModelService.getModels([DossierSituation.Normal], id),
      result => { // TODO: FILTRAR MODELOS DEL TIPO DE EXPEDIENTE SELECCIONADO
        if (result) {
          //tomamos en cuenta el modelo si tiene datos de ficha(EXISTE_FLIC) y es de tipo MOD_LIC
          //Si no está checkeado el filtro de modelos de licitación se mostrarían todos los modelos que tienen datos de licitación independientemente del tipo
          let modelsFlic: any[] = [];
          result.content.forEach(model => {
            if (model.customFields && model.customFields && model.customFields['EXISTE_FLIC'] && model.customFields['EXISTE_FLIC'] == 1) {
              if (this.modelsTenderDefMOD_LIC) {
                if (model.formId === 'MOD_LIC') {
                  modelsFlic.push(model);
                }
              } else {
                modelsFlic.push(model);
              }
            }
          });


          //tomamos en cuenta el modelo si comparte criterios de adjudicación o si este valor no está establecido en el modelo
          this.models = [];
          modelsFlic.forEach(model => {
            if (this.project?.classification?.awardMethod?.identifier
              && model?.classification?.awardMethod?.identifier) {
              if (this.project.classification.awardMethod.identifier == model.classification.awardMethod.identifier) {
                this.models.push(model);
              }
            } else {
              this.models.push(model);
            }
          });

          if (this.models && this.models.length === 0) {
            this.showMessage(this.translate.instant('TenderDefinition.emptymodels'));
          } else {
            this.subscribe(this.helpService.showContextHelpObservable(HelpType.FE_SELECC_MODELO_TENDERDEF));
            this.tenderModelsPopupVisible = true;
          }



        } else {
          this.showMessage(this.translate.instant('TenderDefinition.emptymodels'));
        }
      },
      err => { console.log('Error ', err); this.showMessage(this.translate.instant('TenderDefinition.emptymodels')); });

  }

  showMessage(msg: string) {
    this.uiService.showMessage(msg);
    this.tenderModelsPopupVisible = false;
  }

  public showMessageErrorCreateModel(msg: string): void {
    this.uiService.showMessage(
      msg,
      this.translateService.instant('General.error'),
      'errorStyle'
    );
    this.tenderModelsPopupVisible = false;
  }

  createTenderDefFromModel(model: any) {

    this.uiService.showConfirmMessage({
      message: this.translate.instant('TenderDefinition.confirm.action.import'),
      header: this.translate.instant('TenderDefinition.confirm.action.execute'),
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.confirmCreateTenderDefFromModel(model);
      },
      reject: () => {
        console.log('ELIMINACIÓN CANCELADA');
      }
    });
  }

  confirmCreateTenderDefFromModel(model: any) {

    this.waitService.startWaiting();

    this.subscribe(this.dossierModelService.createTenderDefFromModel(model, this.project.identifier).pipe(finalize(() => {

      this.waitService.cancelWaiting();
    })), (action: ActionResultDTO) => {
      console.log(
        'DEFINICION DE LICITACION CREADA A PARTIR DEL MODEL: ',
        model.identifier,
        action
      );


      if (action.identifier === 'NOK') {
        this.showMessageErrorCreateModel(this.translateService.instant('TenderDefinition.errorimportmodel'));

      }
      if (action.identifier === 'OK') {
        this.showMessage(this.translate.instant('TenderDefinition.importok'));
      }
    },
      err => {
        let msg: string = this.translate.instant('TenderDefinition.errorimportmodel');
        if (err && err.error && err.error.errors) {
          err.error.errors.forEach((error: ValidationExecutionDTO) => { msg = msg + '<br>' + error.message });
        }
        this.showMessageErrorCreateModel(msg);
      });
  }


  onCloseTenderDefModel() {
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.TENDER_DEFINITION));
    this.modelsTenderDefMOD_LIC = true;
    this.loadTenderDef();
  }

  canDeactivate(): boolean | Observable<boolean> | Promise<boolean> {
    if (!this.editDialogOpened) {
      // hay un dialogo de edicion abierto
      // permitir salir si no hay tarea, o lo permite la tarea
      return !this.task || super.canDeactivate();
    }
    return false;
  }

  setEditDialogOpened(editing: boolean) {
    this.editDialogOpened = editing;
  }

  public back(): void {
    if (this.task) {
      this.processTask();
    } else {
      this.uiService.routeBack();
    }
  }

  isViewActive(view: string): boolean {
    if (!this.activeViews || this.activeViews.length === 0) {
      return true;
    }
    return this.activeViews.includes(view);
  }

  loadTenderingCommittes(showLoading?: boolean): Observable<any> {
    if (!this.isViewActive(TenderingDefinitionViews.OA.toString()) && !this.isViewActive(TenderingDefinitionViews.PHASE.toString())) {
      return of(true);
    }
    if (showLoading) {
      this.waitService.startWaiting();
    }
    return this.plycaService
      .query<TenderEvaluationCommitteeDTO>(
        this.configuration.TENDEREVALCOMMITTEE_SERVICE_URL,
        this.getTenderingCommittestQueryParams()
      )
      .pipe(
        tap((value: PaginationDTO<TenderEvaluationCommitteeDTO>) => {
          if (value && value.content) {
            this.tenderEvaluationCommittees = value.content;
          } else {
            this.tenderEvaluationCommittees = new Array<
              TenderEvaluationCommitteeDTO
            >();
          }
        }),
        finalize(() => {
          if (showLoading) {
            this.waitService.cancelWaiting();
          }
        }),
        catchError((error: any) => {
          this.showServerError(error);
          return throwError(error);
        })
      );
  }

  private getTenderingCommittestQueryParams() {
    return {
      procurementProjectId: this.project.identifier,
      expand: 'expansionSet:webclient'
    };
  }

  loadEnvelopes(showLoading?: boolean): Observable<any> {
    if (!this.isViewActive(TenderingDefinitionViews.ENVELOPE.toString()) && !this.isViewActive(TenderingDefinitionViews.PHASE.toString())) {
      return of(true);
    }
    if (showLoading) {
      this.waitService.startWaiting();
    }
    return this.plycaService
      .query<EnvelopeDTO>(
        this.configuration.ENVELOPE_SERVICE_URL,
        this.getTenderingEnvelopesParams()
      )
      .pipe(
        tap((value: PaginationDTO<EnvelopeDTO>) => {
          if (value && value.content) {
            this.tenderingEnvelopes = value.content;
            // lanzar validaciones
            this.tenderingEnvelopes
              .filter((envelope: EnvelopeDTO) => envelope.phase === undefined || envelope.phase.state === TenderingPhaseState.CREATED)
              .forEach((envelope: EnvelopeDTO) => {
                this.envelopeValidations.set(envelope.identifier, this.loadingValidationResult);
                this.valdateEnvelope(envelope);
              })
          } else {
            this.tenderingEnvelopes = new Array<EnvelopeDTO>();
          }
        }),
        finalize(() => {
          if (showLoading) {
            this.waitService.cancelWaiting();
          }
        }),
        catchError((error: any) => {
          this.showServerError(error);
          return throwError(error);
        })
      );
  }

  private valdateEnvelope(envelope: EnvelopeDTO) {
    this.plycaService.validate(this.configuration.ENVELOPE_SERVICE_URL, 'UpdateFLIC', envelope).pipe(
      take(1)
    ).subscribe((validation: ValidationResultDTO) => {
      this.envelopeValidations.set(envelope.identifier, validation);
    }, (error: any) => {
      if (this.formService.isValidationResponse(error)) {
        let validation = error as ValidationResultDTO;
        this.envelopeValidations.set(envelope.identifier, validation);
      } else {
        console.error('error al validar sobre con id' + envelope.identifier, error);
        this.envelopeValidations.delete(envelope.identifier);
      }
    });
  }

  public updateAllEnvelopeOrder(orderedEnvelopes: EnvelopeDTO[]): void {
    if (orderedEnvelopes && this.tenderingPhases) {
      this.tenderingPhases.forEach((phase: TenderingPhaseDTO) => {
        this.updatePhaseEnvelopes(phase.envelopes, orderedEnvelopes)
        if (phase.openingCommittees) {
          phase.openingCommittees.forEach((committee: ProcurementCommitteeDTO) =>
            this.updatePhaseEnvelopes(committee.envelopes, orderedEnvelopes));
        }
      });
    }
  }

  private updatePhaseEnvelopes(unorderedEnvelopes: EnvelopeDTO[], orderedEnvelopes: EnvelopeDTO[]): void {
    if (unorderedEnvelopes) {
      unorderedEnvelopes.forEach((envelope: EnvelopeDTO) => {
        this.updateEnvelopeOrder(envelope, orderedEnvelopes);
      });
    }
  }

  private updateEnvelopeOrder(envelope: EnvelopeDTO, orderedEnvelopes: EnvelopeDTO[]): void {
    let updatedEnvelope = orderedEnvelopes.find((tenderEnvelope: EnvelopeDTO) => tenderEnvelope.identifier === envelope.identifier);
    if (updatedEnvelope) {
      envelope.order = updatedEnvelope.order;
    }
  }
  getTenderingEnvelopesParams() {
    return {
      procurementProjectId: this.project.identifier,
      expand: 'expansionSet:webclient'
    };
  }

  loadTenderingPhases(showLoading?: boolean): Observable<any> {
    if (!this.isViewActive(TenderingDefinitionViews.PHASE.toString())) {
      return of(true);
    }
    if (showLoading) {
      this.waitService.startWaiting();
    }
    return this.plycaService
      .query<TenderingPhaseDTO>(
        this.configuration.TENDERPHASE_SERVICE_URL,
        this.getTenderingPhasesParams()
      )
      .pipe(
        tap((value: PaginationDTO<TenderingPhaseDTO>) => {
          if (value && value.content) {
            this.tenderingPhases = value.content;
            // lanzar validaciones para fases no publicadas
            this.tenderingPhases
              .filter((phase: TenderingPhaseDTO) => phase.state === TenderingPhaseState.CREATED)
              .forEach((phase: TenderingPhaseDTO) => {
                this.envelopeValidations.set(phase.identifier, this.loadingValidationResult);
                this.validatePhase(phase);
              })
          } else {
            this.tenderingPhases = new Array<TenderingPhaseDTO>();
          }
        }),
        finalize(() => {
          if (showLoading) {
            this.waitService.cancelWaiting();
          }
        }),
        catchError((error: any) => {
          this.showServerError(error);
          return throwError(error);
        })
      );
  }

  private validatePhase(phase: TenderingPhaseDTO) {
    let phaseToValidate = lodash.cloneDeep(phase);
    delete phaseToValidate.publications;
    this.plycaService.validate(this.configuration.TENDERPHASE_SERVICE_URL, 'UpdateFLIC', phaseToValidate).pipe(
      take(1)
    ).subscribe((validation: ValidationResultDTO) => {
      this.tenderingPhasesValidations.set(phase.identifier, validation);
    }, (error: any) => {
      if (this.formService.isValidationResponse(error)) {
        let validation = error as ValidationResultDTO;
        this.tenderingPhasesValidations.set(phase.identifier, validation);
      } else {
        console.error('error al validar la fase con id' + phase.identifier, error);
        this.tenderingPhasesValidations.delete(phase.identifier);
      }
    });
  }

  getTenderingPhasesParams() {
    return {
      procurementProjectId: this.project.identifier,
      expand: 'expansionSet:webclient'
    };
  }

  protected showServerError(error: any): void {
    this.plycaErrorHandler.showServerError(error);
  }

  /**
   * Si se elimina un evento de apertura actualizar referencias de sobres.
   * En el servidor ya se limpia
   */
  public updateEnvelopeCommitteeRef(identifier: string): void {
    if (identifier && this.tenderingEnvelopes) {
      this.tenderingEnvelopes
        .filter((envelope: EnvelopeDTO) => envelope.committee && identifier === envelope.committee.identifier)
        .forEach((envelope: EnvelopeDTO) => {
          envelope.committee = undefined;
        })
    }
  }

  public dispatchTask(value: boolean): void {
    if (this.task) {
      this.processTask();
    }
  }

  /**
   * Actualizamos sobres, ya que las fases pueden eliminar referencias de sobre a fase
   * y actualizamos la informacion y validacion del sobre modificado
   */
  public fireTenderingPhaseChange(identifier: string): void {
    let phaseObservable: Observable<any>;
    if (identifier) {
      phaseObservable = this.plycaService.get<TenderingPhaseDTO>(this.configuration.TENDERPHASE_SERVICE_URL,
        identifier,
        this.getTenderingPhasesParams()).pipe(
          tap((updatedPhase: TenderingPhaseDTO) => {
            this.updateTenderingPhaseList(updatedPhase);
          })
        );
    } else {
      // se borro o anyadio el elemento volvemos a leer fases disponibles
      phaseObservable = this.loadTenderingPhases(false);
    }
    // se borro elemento volvemos a leer fases disponibles
    this.waitService.startWaiting();
    let subscription = forkJoin(
      this.loadEnvelopes(false),
      phaseObservable
    ).pipe(
      finalize(() => this.waitService.cancelWaiting())
    ).subscribe();
    this.registerSubscription(subscription);
  }

  private updateTenderingPhaseList(updatedPhase: TenderingPhaseDTO) {
    let updatedPhaseList = new Array<TenderingPhaseDTO>();
    this.tenderingPhases.forEach((phase: TenderingPhaseDTO) => {
      if (phase.identifier === updatedPhase.identifier) {
        if (updatedPhase.state === TenderingPhaseState.CREATED) {
          // actualizar validacion de la fase
          this.validatePhase(updatedPhase);
        }
        // actualizar informacion de la fase
        updatedPhaseList.push(updatedPhase);
      } else {
        updatedPhaseList.push(phase);
      }
    });
    this.tenderingPhases = updatedPhaseList;
  }

  public fireEnvelopeChange(identifier: string): void {
    this.waitService.startWaiting();
    if (identifier) {
      this.plycaService.get<EnvelopeDTO>(this.configuration.ENVELOPE_SERVICE_URL,
        identifier,
        this.getTenderingEnvelopesParams())
        .pipe(
          take(1),
          tap((updatedEnvelope: EnvelopeDTO) => {
            // actualizar informacion del sobre
            this.updateEnvelopeList(updatedEnvelope);
            // actualizar descripciones fases y eventos
            if (updatedEnvelope && this.tenderingPhases) {
              // actualizar descripcion fase
              let phaseFound: TenderingPhaseDTO;
              let phaseEnvelope: EnvelopeDTO;
              // buscar sobre en fases
              this.tenderingPhases.filter((phase: TenderingPhaseDTO) => phase && phase.envelopes)
                .find((phase: TenderingPhaseDTO) => {
                  phaseEnvelope = phase.envelopes
                    .find((envelope: EnvelopeDTO) => envelope.identifier === updatedEnvelope.identifier);
                  if (phaseEnvelope) {
                    phaseFound = phase;
                  }
                  return phaseFound !== undefined;
                });
              if (phaseEnvelope) {
                // actualizar descripcion eventos
                phaseEnvelope.description = updatedEnvelope.description;
                // buscar sobre en eventos de fase asociada al sobre
                if (phaseFound.openingCommittees) {
                  let eventEnvelope: EnvelopeDTO;
                  phaseFound.openingCommittees.filter((committe: ProcurementCommitteeDTO) => committe.envelopes)
                    .find((committe: ProcurementCommitteeDTO) => {
                      eventEnvelope = committe.envelopes
                        .find((envelope: EnvelopeDTO) => envelope.identifier === updatedEnvelope.identifier);
                      return eventEnvelope !== undefined;
                    });
                  if (eventEnvelope) {
                    eventEnvelope.description = updatedEnvelope.description;
                  }
                }
              }
            }
          })
        ).subscribe({ complete: () => this.waitService.cancelWaiting() });
    } else {
      // se borro o anyadio el elemento volvemos a leer
      let subscription = this.loadEnvelopes(true).subscribe();
      this.registerSubscription(subscription);
    }
  }

  private updateEnvelopeList(updatedEnvelope: EnvelopeDTO) {
    let updatedEnvelopeList = new Array<EnvelopeDTO>();
    this.tenderingEnvelopes.forEach((envelope: EnvelopeDTO) => {
      if (envelope.identifier === updatedEnvelope.identifier) {
        updatedEnvelopeList.push(updatedEnvelope);
        this.valdateEnvelope(updatedEnvelope);
      } else {
        updatedEnvelopeList.push(envelope);
      }
    });
    this.tenderingEnvelopes = updatedEnvelopeList;
  }

  public fireTenderingCommitteChange(identifier: string): void {
    this.waitService.startWaiting();
    if (identifier) {
      this.plycaService.get<TenderEvaluationCommitteeDTO>(this.configuration.TENDEREVALCOMMITTEE_SERVICE_URL,
        identifier,
        this.getTenderingEnvelopesParams())
        .pipe(
          take(1),
          tap((updatedCommitte: TenderEvaluationCommitteeDTO) => {
            // actualizar informacion del organo
            this.updateCommitteList(updatedCommitte);
            // actualizar descripciones en eventos
            if (this.tenderingPhases) {
              this.tenderingPhases.filter((phase: TenderingPhaseDTO) => phase && phase.openingCommittees)
                .forEach((phase: TenderingPhaseDTO) => {
                  phase.openingCommittees
                    .filter((phaseCommitte: ProcurementCommitteeDTO) => phaseCommitte.evaluationCommittee)
                    .map((phaseCommitte: ProcurementCommitteeDTO) => phaseCommitte.evaluationCommittee)
                    .forEach((phaseCommitte: TenderEvaluationCommitteeDTO) => {
                      if (phaseCommitte.identifier === updatedCommitte.identifier) {
                        phaseCommitte.description = updatedCommitte.description;
                      }
                    });
                });
            }
          })
        ).subscribe({ complete: () => this.waitService.cancelWaiting() });
    } else {
      // se borro o anyadio el elemento volvemos a leer
      let subscription = this.loadTenderingCommittes(true).subscribe();
      this.registerSubscription(subscription);
    }
  }


  private updateCommitteList(updatedCommitte: TenderEvaluationCommitteeDTO) {
    let updatedCommitteList = new Array<TenderEvaluationCommitteeDTO>();
    this.tenderEvaluationCommittees.forEach((committe: TenderEvaluationCommitteeDTO) => {
      if (committe.identifier === updatedCommitte.identifier) {
        updatedCommitteList.push(updatedCommitte);
      } else {
        updatedCommitteList.push(committe);
      }
    });
    this.tenderEvaluationCommittees = updatedCommitteList;
  }

}
